import { jsx } from "panel";
import { SpinnerEl } from "common/components/spinner";
import { WizardBreadcrumbsEl } from "common/components/wizard-breadcrumbs";
import { thankYouView, thankYouViewMP2023 } from "./thank-you";
import { EnterpriseModal } from "./enterprise-modal";
import breadcrumbsMp23StyleOverride from "./breadcrumbs-mp23.inline.styl";
import breadcrumbsStyleOverride from "./breadcrumbs.inline.styl";
export function template() {
  const org = this.helpers.getOrgPlanInfo();
  const stepComponent = this.helpers.getCurrentStep() ? this.child(this.helpers.getCurrentStep().componentName, {
    attrs: {
      "mp-2023-style": this.attr(`mp-2023-style`),
      ...this.helpers.getCurrentStep().additionalComponentAttrs
    }
  }) : null;
  const isReady = this.helpers.isReady();
  if (this.state.showThankYou && isReady) {
    if (this.attr(`mp-2023-style`))
      return thankYouViewMP2023(this.helpers.checkIfIntegrated());
    else {
      return thankYouView(
        this.helpers.getSelectedCapString(),
        this.helpers.getRenewalDate(),
        this.helpers.checkIfIntegrated()
      );
    }
  }
  return /* @__PURE__ */ jsx("div", {
    sel: this.attr(`mp-2023-style`) ? `.mp2023-plan-builder-wrapper` : `.plan-builder-wrapper`
  }, !isReady ? /* @__PURE__ */ jsx("div", {
    sel: ".spinner-wrapper"
  }, /* @__PURE__ */ jsx(SpinnerEl, null)) : /* @__PURE__ */ jsx("div", {
    sel: ".plan-builder"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".left-pane"
  }, !this.attr(`mp-2023-style`) && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".org-title"
  }, (org == null ? void 0 : org.orgName) || `Your New Organization`), /* @__PURE__ */ jsx("div", {
    sel: ".pane-title"
  }, "Build a Custom Plan")), /* @__PURE__ */ jsx("div", {
    sel: ".pane-breadcrumbs"
  }, /* @__PURE__ */ jsx(WizardBreadcrumbsEl, {
    attrs: {
      breadcrumbs: this.helpers.getBreadcrumbs(),
      "style-override": this.attr(`mp-2023-style`) ? breadcrumbsMp23StyleOverride : breadcrumbsStyleOverride
    },
    on: { nodeClicked: this.helpers.handleBreadcrumbClick }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".step-component-wrapper"
  }, stepComponent)), this.child(`right-pane-2023`, {
    attrs: {
      "mp-2023-style": this.attr(`mp-2023-style`)
    }
  }), EnterpriseModal(
    this.helpers.isEnterpriseCustomer() && !this.attr(`force-org-choice`),
    this.helpers.trackContactSalesClicked
  )));
}
